import { useTranslate } from 'react-admin'
import { Box, Typography } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import { blue, turquoise } from 'src/assets/colors'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'

export const HotelRooms = ({ hotel, rooms, pax_length }) => {
  const translate = useTranslate()
  const iterations = Array.from({ length: pax_length }, (_, index) => index)
  if (rooms && Array.isArray(rooms)) {
    return (
      <>
        <Box>
          <Typography variant='h6' component='div' color={blue} margin={'25px 0px 10px 0px'}>
            {translate('ra.title.rooms')} ({rooms?.length})
          </Typography>
          {rooms.map((room, i) => (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginBottom: 20
              }}
              key={i}
            >
              <Box
                flex={3}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='h7' component='span' fontWeight={600}>
                  {translate('ra.field.type_room')}:
                </Typography>
                <Typography variant='h7' component='span'>
                  {room?.type}
                </Typography>
              </Box>
              <Box
                flex={2}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='h7' component='div' fontWeight={600}>
                  {translate('ra.field.distribution')}:
                </Typography>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  {room?.paxes && room?.paxes?.length !== 0 && Array.isArray(room?.paxes)
                    ? room?.paxes.map((num) => (
                        <Typography key={num} variant='h7' component='div'>
                          <PersonIcon style={{ color: turquoise }} />
                        </Typography>
                      ))
                    : undefined}
                  <Typography variant='h7' component='span'>
                    {((room?.adults || 0) + (room?.children || 0)) || room?.paxes?.length} {translate('ra.title.people_by_room')}
                  </Typography>
                </Box>
              </Box>
              <Box
                flex={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='h7' component='span' fontWeight={600}>
                  {translate('ra.field.regime')}:
                </Typography>
                <Typography variant='h7' component='span'>
                  {room?.boardBase}
                </Typography>
              </Box>
              <Box
                flex={2}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='h7' component='div' fontWeight={600}>
                  {translate('ra.title.passenger')}:
                </Typography>
                {room?.paxes && room?.paxes?.length !== 0 && Array.isArray(room?.paxes)
                  ? room.paxes.map((pax, j) => (
                      <Typography key={j} variant='h7' component='div' display={'flex'}>
                        <PersonIcon style={{ color: turquoise }} /> {pax?.name} {pax?.surname} ({pax?.type})
                      </Typography>
                    ))
                  : undefined}
              </Box>
              <Box
                flex={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='h7' component='span' fontWeight={600}>
                  {translate('ra.field.status')}:
                </Typography>
                <ShowElement data={hotel?.status} onlyValue status />
              </Box>
            </Box>
          ))}
        </Box>
      </>
    )
  }
}
